import {Platform, View} from "react-native"
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AdminButton from "components/admin/button"
import AdminInput from "components/admin/input"
import AdminSelect from "components/admin/select"
import {digg} from "diggerize"
import {Form} from "@kaspernj/api-maker/build/form"
import memo from "set-state-compare/build/memo"
import RenderHtml from "shared/render-html"
import SanitizedHtml from "shared/sanitized-html"
import Services from "@kaspernj/api-maker/build/services"
import {Text} from "shared/base"
import {useAdminLayout} from "components/admin/layout"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import UtilsCard from "components/utils/card"

/** @typedef {object} RoutesAdminLiquidTesterProps */

/**
 * @typedef {object} RoutesAdminLiquidTesterState
 * @property {unknown} errors
 * @property {unknown} form
 * @property {unknown} result
 * @property {string} showAs
 */

/**
 * @extends {ShapeComponent<RoutesAdminLiquidTesterProps, RoutesAdminLiquidTesterState>}
 */
class RoutesAdminLiquidTester extends ShapeComponent {
  /** @type {RoutesAdminLiquidTesterState} */
  state = {
    errors: null,
    form: null,
    result: null,
    showAs: "text"
  }

  setup() {
    const {locale, t} = useI18n({namespace: "js.routes.admin.liquid_tester"})

    this.showOptions = useMemo(
      () => {
        const options = [
          {text: t(".text"), value: "text"},
          {text: t(".react_native"), value: "react-native"}
        ]

        if (Platform.OS == "web") {
          options.push({text: t(".html"), value: "html"})
        }

        return options
      },
      [locale]
    )
    this.t = t


    useAdminLayout()?.setState({active: "liquid-tester", headerTitle: t(".liquid_tester")})
  }

  render() {
    const {t} = this.tt

    return (
      <View dataSet={{route: "admin/liquid-tester"}}>
        <Form onSubmit={this.tt.onSubmit} setForm={this.setStates.form}>
          <AdminInput
            autoRows
            defaultValue=""
            label={t(".liquid_code")}
            multiline
            name="liquid_content"
            style={{marginBottom: 15}}
          />
          <View style={{marginBottom: 15}}>
            <AdminSelect
              defaultValues={["text"]}
              label={t(".show_as")}
              name="show_as"
              options={this.tt.showOptions}
            />
          </View>
          <AdminButton submit title={t("js.shared.submit")} />
        </Form>
        {this.s.errors?.map(({lineNumber, message}, errorIndex) =>
          <UtilsCard header={t("js.shared.error")} key={`${message}:${lineNumber}:${errorIndex}`} style={{marginTop: 15}}>
            <Text>
              {t(".error_on_line", {line_number: lineNumber, message})}
            </Text>
          </UtilsCard>
        )}
        {this.s.result &&
          <UtilsCard style={{marginTop: 15}}>
            {this.s.showAs == "text" &&
              <Text>{this.s.result}</Text>
            }
            {this.s.showAs == "react-native" &&
              <RenderHtml source={this.s.result} />
            }
            {this.s.showAs == "html" &&
              <SanitizedHtml html={this.s.result} />
            }
          </UtilsCard>
        }
      </View>
    )
  }

  onSubmit = async () => {
    const formData = this.s.form.asObject()
    const liquidContent = formData.liquid_content || ""
    const showAs = formData.show_as || "text"

    this.setState({errors: null, result: null})

    const result = await Services.current().sendRequest("LiquidTester", {liquid_content: liquidContent})

    this.setState({
      errors: digg(result, "errors").map(({line_number: lineNumber, message}) => ({lineNumber, message})),
      result: digg(result, "result"),
      showAs
    })
  }
}

export default memo(shapeComponent(RoutesAdminLiquidTester))
